import { EditBase } from "../shared/edit.base";
import { Component, Inject } from "@angular/core";
import { RoleTypeDataService } from "../../core/jobroletypes.dataservice";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "crew-edit-jobroletype",
    template: require('../shared/edit-view.html')
})
export class EditJobRoleType extends EditBase<Nema.Crew.Model.RoleType> {

    constructor(
        stateService: StateService,
        transitionService: TransitionService,
        dialog: MatDialog,
        @Inject('jobRoleType') entity: Nema.Crew.Model.RoleType,
        @Inject(RoleTypeDataService.Id) jobRoleTypeDataService: RoleTypeDataService,
        @Inject('$log') $log: ng.ILogService,
        @Inject('isNew') isNew: boolean) {

        super(stateService, transitionService, dialog, entity, jobRoleTypeDataService, $log, isNew);
    }

    public entityDisplayName = "Job Role";

    public listStateName = "app.settings.jobroletypes";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/jobroletypes/jobroletype.edit.component.ts